import React from "react";
import styled from "styled-components";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

//
import Logo from "../logo/Logo";
import IconWrapper from "../icon-wrapper/IconWrapper";

export default function Footer() {
  const { t } = useTranslation();

  function getThisYear() {
    const date = new Date();

    return date.getFullYear();
  }
  return (
    <StyledFooter>
      <div className="container">
        <div className="footer__wrap">
          <div className="footer__top">
            <div className="footer__top__left">
              <Logo size="lg" />
              <p dangerouslySetInnerHTML={{ __html: t("footerText") }} />
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/Kozklinika"
                    target="__blank"
                  >
                    <IconWrapper
                      w={40}
                      h={40}
                      icon="facebook"
                      iconW={20}
                      iconH={20}
                      animation="scale&&rotate"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/kozklinika/"
                    target="__blank"
                  >
                    <IconWrapper
                      w={40}
                      h={40}
                      icon="instagram"
                      iconW={20}
                      iconH={20}
                      animation="scale&&rotate"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/@ChoriqulShaymatovGavhari"
                    target="__blank"
                  >
                    <IconWrapper
                      w={40}
                      h={40}
                      icon="youtube"
                      iconW={20}
                      iconH={20}
                      animation="scale&&rotate"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://t.me/kozklinika" target="__blank">
                    <IconWrapper
                      w={40}
                      h={40}
                      icon="telegram"
                      iconW={20}
                      iconH={20}
                      animation="scale&&rotate"
                    />
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer__top__right">
              <div className="footer__top__right__list">
                <h1>{t("footerAboutUs")}</h1>
                <ul>
                  <li>
                    <Link to="/about/clinic" className="hover-underline">
                      {t("footerAboutClinic")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/about/doctor" className="hover-underline">
                      {t("footerAboutDoctor")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/about/eye-disease" className="hover-underline">
                      {t("footerAboutEyeDisease")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/about/review" className="hover-underline">
                      {t("footerAboutReview")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/about/faq" className="hover-underline">
                      {t("footerAboutFAQ")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer__top__right__list">
                <h1>{t("footerService")}</h1>
                <ul>
                  <li>
                    <Link to="/service/all" className="hover-underline">
                      {t("footerServiceAll")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service/1" className="hover-underline">
                      {t("footerServiceEyeFullCheck")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service/2" className="hover-underline">
                      {t("footerServiceContactLensCheck")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service/3" className="hover-underline">
                      {t("footerServiceFullOpticCheck")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service/4" className="hover-underline">
                      {t("footerServiceEyeCare")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer__top__right__list">
                <h1>{t("footerContact")}</h1>
                <ul>
                  <li className="contact__li">
                    <i className="icon icon-phone"></i>
                    <a
                      href="tel:+998954100014"
                      target="__blank"
                      className="hover-underline"
                    >
                      +998 (95) 410 00 14
                    </a>
                  </li>
                  <li className="contact__li">
                    <i className="icon icon-phone"></i>
                    <a
                      href="tel:+998792100014"
                      target="__blank"
                      className="hover-underline"
                    >
                      +998 (79) 210 00 14
                    </a>
                  </li>
                  <li className="contact__li">
                    <i className="icon icon-mail"></i>
                    <a
                      href="mailto:choriqulshaymatov@gmail.com"
                      target="__blank"
                      className="hover-underline"
                    >
                      choriqulshaymatov@gmail.com
                    </a>
                  </li>
                  <li className="contact__li">
                    <i className="icon icon-location"></i>
                    <a
                      href="https://yandex.uz/maps/10334/samarkand/house/Yk8YfwFgQEcDQF1jfXp0dHhmbQ==/?from=mapframe&ll=66.960924%2C39.655460&z=16"
                      target="__blank"
                      className="hover-underline"
                      dangerouslySetInnerHTML={{
                        __html: t("footerAddressText"),
                      }}
                    ></a>
                  </li>
                  <li className="contact__li">
                    <i className="icon icon-location"></i>
                    <a
                      href="https://yandex.uz/maps"
                      target="__blank"
                      className="hover-underline"
                      dangerouslySetInnerHTML={{
                        __html: t("footerAddressText2"),
                      }}
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <p>
          <a
            href="https://t.me/+998939980989"
            target="__blank"
            className="hover-underline"
          >
            Avazov Ulug'bek
          </a>{" "}
          <span>
            &copy; {t("footerCopyright")} {getThisYear()}
          </span>
        </p>
      </div>
    </StyledFooter>
  );
}

const StyledFooter = styled.footer`
  background-color: var(--dark-blue);

  .footer {
    &__wrap {
      padding: 140px 0;
    }

    &__top {
      display: flex;
      gap: 72px;

      &__left {
        & > p {
          color: var(--white);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px; /* 146.667% */
          margin-top: 24px;
          max-width: 350px;
        }

        ul {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-top: 72px;
        }
      }

      &__right {
        flex: 1;
        gap: 24px;
        padding-top: 32px;
        display: flex;
        justify-content: space-around;

        &__list {
          h1 {
            color: var(--white);
            font-size: 22px;
            font-style: normal;
            font-weight: 500;
            line-height: 30px;
            margin-bottom: 32px;
          }

          ul {
            display: flex;
            flex-direction: column;
            gap: 20px;

            li {
              a {
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
                position: relative;
                width: max-content;
              }

              &.contact__li {
                display: flex;
                align-items: center;
                gap: 12px;

                i {
                  width: 18px;
                  height: 18px;
                }
              }
            }
          }
        }
      }
    }

    &__bottom {
      border-top: 1px solid #44639d;

      p {
        padding: 40px 0;
        color: #dbe6ee;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 125% */
      }
    }
  }
`;
